// 1. 외부 패키지
import { Suspense } from "react";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import TableSkeleton from "./table-skeleton";
import Table from "./table";


// 4. 타입

const TableWrapper = () => {
	return (
		<Suspense fallback={<TableSkeleton />}>
			<Table />
		</Suspense>
	);
};

export default TableWrapper;